export default __webpack_public_path__ + "static/media/Logo-black-1.e258a45c.svg";